import { translate as tr } from "./i18n";

const statusLabels: Record<string, string> = {
  draft: "Черновик", review: "На согласовании", confirmed: "Подтвержден", cancelled: "Отменен", closed: "Закрыт",
  approved: "Утверждена", superseded: "Заменена", active: "Активен", archive: "Архив", obsolete: "Устарела",
  shortage: "Дефицит", partial: "Частично", covered: "Обеспечено", ordered: "Заказано", sent: "Отправлен", received: "Получен",
  posted: "Проведен", consumed: "Использован", released: "Снят", depleted: "Израсходована", blocked: "Заблокирована",
  issue: "Выдача", return: "Возврат", writeoff: "Списание", transfer: "Перемещение", receipt: "Приход",
  receipt_reversal: "Сторно прихода", reserve_issue: "Выдача резерва", transfer_out: "Перемещение −", transfer_in: "Перемещение +",
  inventory_adjustment: "Корректировка", reversal: "Сторно", none: "Не запрошена", pending: "На согласовании", rejected: "Отклонена",
  planned: "Запланировано", in_progress: "В работе", completed: "Завершено", materials_issued: "Материалы выданы",
  cutting: "Раскрой", cut: "Комплектование", sewing: "Пошив", sewn: "Пошив завершен", paused: "Пауза",
  queued: "Очередь", delayed: "Задержка", qc: "ОТК", issued: "Материал выдан",
  quality: "Контроль качества", rework: "Доработка", accepted: "Принято ОТК", packed: "Упаковано",
  finished_goods: "Готовая продукция", shipped: "Отгружено", sealed: "Упакована", reserved: "Зарезервировано",
  minor: "Незначительный", major: "Значительный", critical: "Критический", reinspected: "Повторно проверена",
  present: "Присутствовал", absent: "Отсутствовал", leave: "Отпуск", sick: "Больничный", suspended: "Приостановлен",
  dismissed: "Уволен", calculated: "Рассчитана", exported: "Экспортирована",
  overdue: "Просрочка", approval: "Согласование", ready_to_ship: "Готово к отгрузке", payroll: "Начисления",
  info: "Информация", warning: "Предупреждение",
  running: "Выполняется", succeeded: "Успешно", failed: "Ошибка", open: "Открыта", retrying: "Повтор",
  resolved: "Устранена", full_backup: "Полная копия", wal_archive: "WAL-архив", restore_drill: "Restore drill",
};

export function statusLabel(value: string) {
  return tr(statusLabels[value] ?? value);
}
